function showSuccess(step, name) {
  const form = MultiStepForm[step];
  // Ensure the property exists before trying to modify classes or set value
  if (form && form.hasOwnProperty(name)) {
    jQuery(`.field-LeadForm-${name}`).addClass("has-success")
    jQuery(`.field-LeadForm-${name}`).removeClass("has-error")

    var feedback = document.getElementById(`error_${name}`)
    if (feedback) {
      feedback.innerHTML = ""
      // Optionally hide the error container if it uses d-none
      jQuery(`#error_${name}`).addClass("d-none");
    }
    form[name] = true
  } else {
    // Log if the field name doesn't exist in the step's config
    // console.warn(`Field "${name}" not found in MultiStepForm[${step}] for success`);
  }
}

function showError(step, name, field, value, override = "") {
  const form = MultiStepForm[step]
   // Ensure the property exists before trying to modify classes or set value
  if (form && form.hasOwnProperty(name)) {
    jQuery(`.field-LeadForm-${name}`).addClass("has-error")
    jQuery(`.field-LeadForm-${name}`).removeClass("has-success") // Ensure success is removed on error
    jQuery(`#error_${name}`).removeClass("d-none") // Make sure error message is visible

    let text = `Por favor, ingresa un ${field} válido.`
    // Use more specific check for empty value, trim whitespace
    // Check specifically for null/undefined as well for robustness
    if (value === "" || value === null || value === undefined || (typeof value === 'string' && value.trim() === "")) {
      text = `Por favor, ingresa tu ${field}.`
    }

    if (override && override !== "") {
      text = override
    }

    let errorElm = document.getElementById(`error_${name}`)
    if(errorElm){
      errorElm.innerHTML = text
    }
    form[name] = false
  } else {
     // Log if the field name doesn't exist in the step's config
    // console.warn(`Field "${name}" not found in MultiStepForm[${step}] for showing error`);
  }
}

function validateForm(step) {
  // Trigger validation logic for all relevant fields first
  if (step == 1) {
    triggerStep1Elements()
  } else if (step == 2) {
    triggerStep2Elements()
  } else if (step == 3) {
    triggerStep3Elements()
  } else if (step == 4) {
    triggerStep4Elements()
  } else if (step == 5) {
    triggerStep5Elements()
  }

  // Now check the state object
  const form = MultiStepForm[step]
  if (!form) {
      console.error(`MultiStepForm configuration for step ${step} is missing.`);
      return false;
  }

   // --- Specific checks for Step 4 conditional fields ---
   if (step === 4) {
        // Check employment_start_date requirement
        const occupationValue = $('#form-step-4 input[name="LeadForm[occupation]"]:checked').val();
        if (occupationValue === "EMPLOYED_INDEFINITE_PERIOD") {
            // If required but not valid, ensure state is false
            if (!validateEmploymentStartDate()) { // Assumes validateEmploymentStartDate exists
                 MultiStepForm[4].employment_start_date = false;
                 // Ensure error is shown if not already
                 if (!$(".field-LeadForm-employment_start_date").hasClass('has-error')) {
                      $("#form-date-step-4 select[data-name='employment_start_date']").trigger('change');
                 }
            } else {
                 MultiStepForm[4].employment_start_date = true;
            }
        } else {
             // If not required, ensure state is true for validation check
             if (MultiStepForm[4].hasOwnProperty('employment_start_date')) {
                 MultiStepForm[4].employment_start_date = true;
             }
        }

        // Check car_plate_number requirement
        const carOwnerValue = $('#form-step-4 input[name="LeadForm[car_owner]"]:checked').val();
        if (carOwnerValue === "YES") {
             // If required but not valid, ensure state is false
             if (!validateCarPlateNumber($("#LeadForm-car_plate_number").val())) { // Assumes validateCarPlateNumber exists
                  MultiStepForm[4].car_plate_number = false;
                  // Ensure error is shown if not already
                  if (!$(".field-LeadForm-car_plate_number").hasClass('has-error')) {
                       $("#LeadForm-car_plate_number").trigger('keyup');
                  }
             } else {
                 MultiStepForm[4].car_plate_number = true;
             }
        } else {
             // If not required, ensure state is true for validation check
             if (MultiStepForm[4].hasOwnProperty('car_plate_number')) {
                 MultiStepForm[4].car_plate_number = true;
             }
        }
   }
   // --- End of Step 4 specific checks ---


  // Check if all defined fields in the step's config are true
  const allValid = Object.keys(form).every((key) => form[key] === true);


  if (!allValid) {
      // Optional: Log which fields are failing validation
      // console.log(`Current Step ${step} State:`, MultiStepForm[step]); // Log state on failure
      for (const [key, value] of Object.entries(form)) {
          if (value !== true) {
              console.log(`Validation failed for step ${step}, field: ${key}`);
          }
      }
      // Find the first element with has-error within the current step's form
      var firstError = jQuery(`#form-step-${step} .has-error`).first();
      if (firstError.length) {
           scrollToErrorElement(firstError); // Scroll to the specific error
      }
      return false;
  }

  return true; // All fields are valid
}

// Function to scroll to a specific error element or the first one
function scrollToErrorElement(element = null) {
    var targetElement = element ? $(element) : jQuery(".has-error").first(); // Use provided element or find first error
    if (targetElement.length) {
        var top = targetElement.offset().top;
        var headerHeight = jQuery("header.header").height() || 60; // Use header height or a default
        var scrollToPosition = top - headerHeight - 20; // Adjust offset as needed

        jQuery('html, body').animate({ scrollTop: scrollToPosition }, 500); // Smooth scroll
    }
}


// --- Trigger Functions ---

const triggerStep1Elements = () => {
  // recaptchaCallback() // Assuming this handles its own validation state update

  // Trigger validation handlers for inputs and checkboxes
  jQuery("#form-input-step-1 input").trigger("keyup")
  jQuery("#form-checkbox-step-1 input").trigger("change")

  // Explicitly check recaptcha status if needed here
  // recaptchaCallback might need to be called or its result checked
  // Example: if (!MultiStepForm[1].recaptcha) { showError(1, 'recaptcha', ...); }
}

const triggerStep2Elements = () => {
  // Trigger validation for text inputs
  jQuery("#form-input-step-2 input").trigger("keyup");

  // Explicitly check radio button state for housing_type
  const isHousingTypeSelected = jQuery('#form-step-2 input[name="LeadForm[housing_type]"]:checked').length > 0;
  if (isHousingTypeSelected) {
      showSuccess(2, 'housing_type');
  } else {
      // Use the specific error message function
      showError(2, 'housing_type', '¿En dónde vives?', '', 'Por favor, selecciona dónde vives.');
  }
};


const triggerStep3Elements = () => {
  // Trigger validation for selects (nationality, marital status, birth date parts)
  jQuery("#form-selector-step-3 select").trigger("change")
  jQuery("#form-date-step-3 select").trigger("change")

  // Directly check radio button states instead of triggering change
  const isGenderSelected = jQuery('#form-step-3 input[name="LeadForm[gender]"]:checked').length > 0;
  if (isGenderSelected) {
      showSuccess(3, 'gender');
  } else {
      // Use the specific error message function
      showError(3, 'gender', 'Genero', '', 'Por favor, selecciona tu Genero.');
  }

  const isPhonePlanSelected = jQuery('#form-step-3 input[name="LeadForm[phone_plan]"]:checked').length > 0;
  if (isPhonePlanSelected) {
      showSuccess(3, 'phone_plan');
  } else {
      // Use the specific error message function
      showError(3, 'phone_plan', 'Tipo de contrato', '', 'Por favor, selecciona tu Tipo de contrato.');
  }
}

const triggerStep4Elements = () => {
    // Trigger basic input validation
    jQuery("#form-input-step-4 input[data-name='neto_income']").trigger("keyup");
    jQuery("#form-input-step-4 input[data-name='monthly_expenses']").trigger("keyup");

    // Trigger date validation
    jQuery("#form-date-step-4 select[data-name='remuneration_deadline']").trigger("change");
    // Employment start date validation is handled conditionally within validateForm

    // Trigger radio button validation checks directly
    const isOccupationSelected = jQuery('#form-step-4 input[name="LeadForm[occupation]"]:checked').length > 0;
    if (isOccupationSelected) {
        showSuccess(4, 'occupation');
    } else {
        showError(4, 'occupation', 'Situación laboral', '', 'Por favor, selecciona tu Situación laboral.');
    }

    const isCarOwnerSelected = jQuery('#form-step-4 input[name="LeadForm[car_owner]"]:checked').length > 0;
    if (isCarOwnerSelected) {
        showSuccess(4, 'car_owner');
    } else {
        showError(4, 'car_owner', 'Vehículo en propiedad', '', 'Por favor, selecciona si tienes un vehículo en propiedad.');
    }

    // Car plate number and employment start date validation are handled conditionally within validateForm
    // We trigger their respective inputs/selects here to ensure their individual handlers run if they are visible
    if ($(".field-LeadForm-employment_start_date").is(":visible")) {
         $("#form-date-step-4 select[data-name='employment_start_date']").trigger('change');
    }
     if ($(".field-LeadForm-car_plate_number").is(":visible")) {
         $("#LeadForm-car_plate_number").trigger('keyup');
     }
};


const triggerStep5Elements = () => {
  jQuery("#form-input-step-5 input").trigger("keyup")
  // Add triggers for any other fields in step 5 if necessary
}
